var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner"},[_c('h2',{staticClass:"title"},[_vm._v("合作伙伴")]),_c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.url}})])}))])}
var staticRenderFns = []

export { render, staticRenderFns }